const CommonListKeys = {
  TITLE: "Title",
  BRANCHES: "Branches",
  RELATIONSHIP: "RELATIONSHIP",
  MEMBERSHIP_CARD_TYPE: "MembershipCardType",
};
export default CommonListKeys;
